import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_ProductGet, Model_ProductPictureGet, Shared_Languages, Shared_PictureResolutions } from "src/backend/openapi/v1";
import { SinglePicture } from "./product-details-types";

export enum Action {
  GetProductByProductIdRequest = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETPRODUCTBYPRODUCTIDREQUEST",
  GetProductByProductIdSuccess = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETPRODUCTBYPRODUCTIDSUCCESS",
  GetProductByProductIdFail = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETPRODUCTBYPRODUCTIDFAIL",
  GetProductByProductIdReset = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETPRODUCTBYPRODUCTIDRESET",

  GetProductPicturesRequest = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETPRODUCTPICTURESREQUEST",

  getSingleProductPictureRequest = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETSINGLEPRODUCTPICTUREREQUEST",

  getMultipleProductPicturesRequest = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:GETMULTIPLEPRODUCTPICTURESREQUEST",

  Clear = "@@ITK:SRC:PAGES:PRODUCT-DETAILS:PRODUCT-DETAILS-STORE.TS:ACTION:CLEAR"
}

type productDetailsState = {
  productState: Loading<Model_ProductGet>;
};

const initialState: productDetailsState = {
  productState: loadingNotStarted
};

export const productDetailsActions = {
  getProductByProductIdRequest: (productId: string, language: Shared_Languages) => actionCreator(Action.GetProductByProductIdRequest, { productId, language }),
  getProductByProductIdSuccess: (data: Model_ProductGet) => actionCreator(Action.GetProductByProductIdSuccess, { data }),
  getProductByProductIdFail: () => actionCreator(Action.GetProductByProductIdFail),
  getProductByProductIdReset: () => actionCreator(Action.GetProductByProductIdReset),
  getProductPicturesRequest: (productId: string, resolution: Shared_PictureResolutions, callBack: (isSuccess: boolean, data?: Model_ProductPictureGet[]) => void, productPictureIds?: string[]) =>
    actionCreator(Action.GetProductPicturesRequest, {
      productId,
      resolution,
      callBack,
      productPictureIds
    }),

  getSingleProductPictureRequest: (pictureId: string, resolution: Shared_PictureResolutions, callBack: (isSuccess: boolean, data?: SinglePicture) => void) =>
    actionCreator(Action.getSingleProductPictureRequest, { pictureId, resolution, callBack }),

  getMultipleProductPicturesRequest: (productPictureIds: string[], resolution: Shared_PictureResolutions, callBack: (isSuccess: boolean, data?: SinglePicture[]) => void) =>
    actionCreator(Action.getMultipleProductPicturesRequest, { productPictureIds, resolution, callBack }),

  clear: () => actionCreator(Action.Clear)
};

export const productDetailsReducer = (state = initialState, action: ActionReturnType<typeof productDetailsActions>): productDetailsState => {
  switch (action.type) {
    case Action.GetProductByProductIdRequest:
      return { ...state, productState: loadingIsLoading };
    case Action.GetProductByProductIdSuccess:
      return { ...state, productState: loadingFinished(action.payload.data) };
    case Action.GetProductByProductIdFail:
      return { ...state, productState: loadingFailed };
    case Action.GetProductByProductIdReset:
      return { ...state, productState: loadingNotStarted };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
